import { Analysis, IGetEffectReportDetailsResp, Topic } from '../../../services/reports';

const parseRelatedTopics = (data: Analysis, effectData: IGetEffectReportDetailsResp | null) => {
  return data.included_topics.reduce<Topic[]>((acc, code) => {
    const matchingTopic = effectData?.topics.find(topic => topic.code === code);
    if (matchingTopic) {
      acc.push(matchingTopic);
    }
    return acc;
  }, []);
};

export default parseRelatedTopics;
